import { fetchApi } from '@/config/axiosSetting';
import {
  VisitInformationResponseType,
  VisitInformationTypeParams,
} from '@/modules/adjusterReportModules/IncidentParticipants/queries/getVisitInformation/getVisitInformationQuer.type';

export const getInitialVisitInformationQueryFunction = (
  params: VisitInformationTypeParams,
): Promise<VisitInformationResponseType> => {
  return fetchApi.get(
    `/initial/reports/${params.id}/adjusting/visit_information/`,
    {
      params: {
        id: params.id,
      },
    },
  );
};
